import dayjs from 'dayjs';
import { UsageLogsColumnsOptions } from '../../../usage';
import { UsageReport } from '../../../usage/interfaces/usage-report.interface';
import { en } from '../../theme/languages/en';
import { DATE_FORMAT, numberWithCommasFixedNumbers } from '../../utils';

export const metadataItems = (usageReport: UsageReport) => [
  {
    key: en.period,
    value: `${dayjs(usageReport.startDate).format(DATE_FORMAT)} - ${dayjs(usageReport.endDate).format(DATE_FORMAT)}`,
  },
  {
    key: en.logs,
    value: numberWithCommasFixedNumbers(usageReport.usageLogsTable.rows.length, 0),
  },
  {
    key:
      (usageReport?.columnMapping && usageReport?.columnMapping[UsageLogsColumnsOptions.QUANTITY]?.keyTitle) || en.qty,
    value: typeof usageReport?.quantity === 'number' ? numberWithCommasFixedNumbers(usageReport?.quantity) : '-',
  },
];
